/**
 * Auto-generate a short code from an organization name.
 * - Multi-word: first letter of each word (up to 4), e.g. "Neon Knights Gaming" → "NKG"
 * - Single word: keep first letter + strip vowels from the rest, e.g. "Carousel" → "CRSL"
 * - Uppercase, alphanumeric only, max 4 chars
 */
export function generateCode(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean)
  if (words.length === 0) return ''

  let code: string
  if (words.length === 1) {
    const clean = words[0].replace(/[^a-zA-Z0-9]/g, '')
    if (clean.length === 0) return ''
    const first = clean[0]
    const rest = clean.slice(1).replace(/[aeiou]/gi, '')
    code = (first + rest).slice(0, 4)
  } else {
    code = words
      .map((w) => w.replace(/[^a-zA-Z0-9]/g, '').charAt(0))
      .filter(Boolean)
      .slice(0, 4)
      .join('')
  }

  return code.toUpperCase()
}
